import React, { Fragment, useState } from 'react'
import styled from '@emotion/styled'
import { Form, Input, Select, Button } from 'antd'
import { useGlobalConfig } from 'context/config-context'
import Filters from 'views/ScanSettings/NewScan/components/Filters'
import WebHooks from 'views/ScanSettings/NewScan/components/WebHooks'
import { validateFilters } from 'views/ScanSettings/NewScan/steps/validate'
import { SaveItemButtonPrimary } from 'views/ScanSettings/NewScan/style'
import { validateRule } from './validate';

import {
	RULES,
	RULE_NAME,
	RULE_FILTERS,
	RULE_TRIGGER,
	RULE_ACTION_TYPE,
	RULE_ACTION_TYPE_EMAIL,
	RULE_ACTION_TYPE_WEBHOOK,
	RULE_ACTION_EMAIL_VALUE,
	WEBHOOKS,
	RULE_PREFIX,
	SUCCESS
} from 'views/ScanSettings/NewScan/constants'
import DynamicForm from 'views/ScanSettings/NewScan/components/DynamicForm'

const { Option } = Select

const RuleSection = styled.div({
	marginBottom: 40
})

const SectionTitle = styled.h3({
	marginBottom: 20,
	fontSize: 18
})

const StyledTriggerRow = styled.div({
	display: 'grid',
	gridTemplateColumns: '200px 1fr',
	gridGap: 20
})

const RulesActionButtonsContainer = styled.div({
	marginBottom: "20px"
})

const RuleActionButton = styled(Button)({
	display: 'inline',
	marginRight: '10px',
})


const rules = []

const PostFlowStep = ({ form, filters, webhooks, rules, setValidationError,  setIsValidating}) => {
	const config = useGlobalConfig()
	const { getFieldDecorator, getFieldValue } = form
	const [isFilterVisible, showFilterField] = useState(true);
	const [isWebhookFormVisible, toggleWebHookForm] = useState(false);
	const [isMailFormVisible, showMailForm] = useState(false);
	
	let ruleActionType = getFieldValue(RULE_ACTION_TYPE)

	const onAddNewRule = async rule => {
		if (rule.filters) {
			try {
				setValidationError(null)
				setIsValidating(true)
				const errors = await validateFilters(rule.filters)
				setIsValidating(false)
				if (errors) {
					setValidationError(errors.errors)
				}
			} catch (e) {
				setValidationError([e.message])
			}
		}
	}

	const onRemoteValidation = async (values) => {
		let failureResponse = await validateRule([values]);
		return failureResponse ? failureResponse : SUCCESS;		
	}

	const RuleActionFields = (
		<Fragment>
			<Fragment>
				<RulesActionButtonsContainer>
					<RuleActionButton type="primary" icon={isMailFormVisible ?  "minus" : "plus" } onClick={() => showMailForm(!isMailFormVisible)}>
						Mail
					</RuleActionButton>
					<RuleActionButton type="primary" icon={isWebhookFormVisible ?  "minus" : "plus" } onClick={() => toggleWebHookForm(!isWebhookFormVisible)}>
						Webhook
					</RuleActionButton>
				</RulesActionButtonsContainer>
			</Fragment>
			{isWebhookFormVisible && (
				<WebHooks setValidationError={setValidationError} form={form} webhooks={webhooks} multiple={true} prefix={RULE_PREFIX} />
			)}
			{ isMailFormVisible && (
				<Form.Item label="MAIL TO">
					{getFieldDecorator(RULE_ACTION_EMAIL_VALUE, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								whitespace: true,
								message: 'Required'
							}
						]
					})(<Input placeholder="MAIL TO" />)}
				</Form.Item>
			)}
		</Fragment>
	)

	return (
		<DynamicForm
			remoteValidation={async (values) => await onRemoteValidation(values)}
			form={form}
			dataList={rules}
			dataType={RULES}
			dataTypeText="Rules"
			formFields={[
				RULE_FILTERS,
				RULE_NAME,
				RULE_ACTION_TYPE,
				RULE_TRIGGER,
				RULE_ACTION_EMAIL_VALUE,
				`${RULE_PREFIX}${WEBHOOKS}`
			]}
			nameProp={RULE_NAME}
			onAddNewItem={onAddNewRule}
			primary
			setValidationError={setValidationError}
		>
			<RuleSection>
				<Form.Item label="RULE NAME">
					{getFieldDecorator(RULE_NAME, {
						validateTrigger: ['onChange', 'onBlur'],
						rules: [
							{
								required: true,
								whitespace: true,
								message: 'Required'
							}
						]
					})(<Input placeholder="Rule Name" />)}
				</Form.Item>
			</RuleSection>
			<RuleSection>
				<SectionTitle>On</SectionTitle>
				<StyledTriggerRow>
					{getFieldDecorator(RULE_TRIGGER,{initialValue: "success"})(
						<Select placeholder="Actions" onSelect={(val) => {showFilterField(val === "success")}}>
							{config['rule_conditions'].map(item => (
								<Option key={item} value={item}>
									{item}
								</Option>
							))}
						</Select>
					)}
				</StyledTriggerRow>
			</RuleSection>
			{( isFilterVisible &&
				<RuleSection>
					<SectionTitle>Filters</SectionTitle>
					<Filters setValidationError={setValidationError} showNameField="true" form={form} filters={filters} />
				</RuleSection>)
			}
			<SectionTitle>Actions</SectionTitle>
			{RuleActionFields}
		</DynamicForm>
	)
}

export default PostFlowStep
